import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SiteExperimentsService } from './siteExperimentsService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SiteExperimentsService)
}

export const editor = site
